import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'frontend-monorepo-preset-reset-setting-dialog',
  templateUrl: './preset-reset-setting-dialog.component.html',
  styleUrls: ['./preset-reset-setting-dialog.component.scss']
})
export class PresetResetSettingDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<PresetResetSettingDialogComponent>
  ) { }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

}
